import favicon from 'assets/img/themes/prevost/favicon.ico';
import background from 'assets/img/themes/prevost/background.png';
import logo from 'assets/img/themes/prevost/logo.png';
import sidebarLogo from 'assets/img/themes/prevost/logo-sidebar.png';
import collapsed from 'assets/img/themes/prevost/logo-sidebar-collapsed.png';

export default {
  background: {
    src: background,
  },
  logo: {
    src: logo,
    height: '156px',
  },
  sidebar: {
    logo: sidebarLogo,
    collapsed: collapsed,
  },
  page: {
    title: 'Prevost Rental',
    favicon: favicon,
    support: 'Prevost Rental Support',
  },
  footer: {
    url: 'https://launchmobility.com',
    copyright: 'Prevost Rental Inc.',
    version: false,
    year: 2020,
  },
};
